goog.provide('yext.social.partners');

/** @const */ yext.social.partners.FACEBOOK_ID = 559;
/** @const */ yext.social.partners.FOURSQUARE_ID = 440;
/** @const */ yext.social.partners.GOOGLE_PLACES_ID = 558;
/** @const */ yext.social.partners.HEROLD = 648;
/** @const */ yext.social.partners.INSTAGRAM_ID = 610;
/** @const */ yext.social.partners.TWITTER_ID = 689;
/** @const */ yext.social.partners.WIDGETS = 582;
/** @const */ yext.social.partners.YELLOW_CAULDRON_ID = 427;

/** @type {!Object} */
yext.social.partners.locationsToPartnerIds;

/** @type {!Object} */
yext.social.partners.locationsToWidgets;

/** @type {boolean} */
yext.social.partners.hasSocialWidgets;

yext.social.partners.init = function(locationsToPartnerIds,
  locationsToWidgets,
  hasSocialWidgets) {
  yext.social.partners.locationsToPartnerIds = locationsToPartnerIds;
  yext.social.partners.locationsToWidgets = locationsToWidgets;
  yext.social.partners.hasSocialWidgets = hasSocialWidgets;
};
goog.exportSymbol('yext.social.partners.init', yext.social.partners.init);
